'use client';
import styled from 'styled-components';

export const HideOnMobile = styled.div`
  display: none;

  @media ${props => props.theme.tablet} {
    display: initial;
  }
`;
